import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import {
  selectUser,
  selectIsShowJackpotModal,
  selectIsHhOverlayOpen,
} from '@homeplay/app';
import JackpotHomepageModal from './JackpotHomepageModal';

  const PromoBonusesModal = () => {
  const isShowJackpotModal = useSelector(selectIsShowJackpotModal);
  const isHhOverlayOpen = useSelector(selectIsHhOverlayOpen);
  const user = useSelector(selectUser);
  const happyHourBonus = useSelector((state) => state.promotions.happyHourBonus);
  const location = useLocation();

  const isGamePage = location.pathname.includes('/game/');
  const isHhGetBonusActive = useMemo(() => {
    if (!user || !happyHourBonus?.isComplete || !Array.isArray(happyHourBonus?.bonusStates)) {
      return false;
    }
    const totalCompleted = happyHourBonus.bonusStates
      .filter((s) => s && s.complete)
      .reduce((sum, s) => sum + (s.amount || 0), 0);
    return totalCompleted > 0;
  }, [user, happyHourBonus]);
  
  const canShowJackpot =
    !isGamePage &&
    isShowJackpotModal &&
    !!happyHourBonus?.fetched &&
  !isHhGetBonusActive &&
  !isHhOverlayOpen;

  if (canShowJackpot) {
    return (
      <CSSTransition in={true} timeout={0} classNames="modal" unmountOnExit>
        <JackpotHomepageModal />
      </CSSTransition>
    );
  }

  return null;
};

export default PromoBonusesModal;
